import {useState, useEffect} from 'react';

const getHeight = () =>
  window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

export const useBrowserHeight = ({timeout} = {timeout: 150}) => {
  const [height, setHeight] = useState(getHeight());

  useEffect(() => {
    let timeoutId = null;
    const resizeListener = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => setHeight(getHeight()), timeout);
    };

    window.addEventListener('resize', resizeListener);

    return () => {
      window.removeEventListener('resize', resizeListener);
    };
  }, [timeout]);

  return height;
};
